import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getContactUsPage = createAsyncThunk('contactPage/getContactUsPage', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getContactPage();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
